import { isLuxPlusSubscriptionItem } from 'lib/checkout/checkoutUtils'
import { getCanRedeemLuxPlusBenefitsOnOrder, getIsEnabledFlightsLuxPlusPricing } from 'luxPlus/selectors/featureToggle'
import { createSelector } from 'reselect'

const getIsLuxPlusPricedFlight = createSelector(
  (state: App.State) => getIsEnabledFlightsLuxPlusPricing(state),
  (state: App.State) => getCanRedeemLuxPlusBenefitsOnOrder(state),
  (state: App.State) => state.checkout.cart.items,
  (isFlightsLuxPlusPricingEnabled, canRedeemLuxPlusBenefitsOnOrder, checkoutItems): boolean => {
    const canUseLuxPlusFlightPricing =
      canRedeemLuxPlusBenefitsOnOrder || checkoutItems.some(isLuxPlusSubscriptionItem)
    return !isFlightsLuxPlusPricingEnabled || canUseLuxPlusFlightPricing
  },
)

export default getIsLuxPlusPricedFlight
